import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getUKCountry,
  UK_COUNTRY_TO_VANITY,
} from '../../services/signup-service';
import { FLOW_STORAGE_KEY } from '../../services/flow-service';

// Flow 391 is the 'nhs' slug flow — stable across environments
const NHS_FLOW_ID = 391;

const CreateAccountPreFlow: React.FC = () => {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const redirectUrl = params.get('redirect_url') ?? '';
    const qs = redirectUrl
      ? `?redirect_url=${encodeURIComponent(redirectUrl)}`
      : '';

    const existingCountry = getUKCountry();
    if (existingCountry && UK_COUNTRY_TO_VANITY[existingCountry]) {
      window.location.replace(
        `/sleepio/${UK_COUNTRY_TO_VANITY[existingCountry]}${qs}`
      );
      return;
    }

    // Pre-warm flow 391 at #2/1 (country selector) so the engine skips the #1/1 welcome screen.
    // The flow reducer validates flowId before using saved progress (hasProgressForFlow in flow-reducer.js).
    localStorage.setItem(
      FLOW_STORAGE_KEY,
      JSON.stringify({ flowId: NHS_FLOW_ID, currentStep: 1, currentPage: 0 })
    );
    window.location.replace(`/sleepio/nhs${qs}`);
  }, [search]);

  return null;
};

export default CreateAccountPreFlow;
